import React from 'react'
import { Box, Typography } from '@mui/material'

const TONE = { blue: '#1e88e5', grey: '#616161', amber: '#ff8f00', teal: '#26a69a', green: '#43a047' }

// One mini tape (maqueta `.mini`): a row per line, its segments by percentage of the range. Marks: «adjusted» (dashed border)
// and «filled» (hatched), the same look as the timeline. `data-*` carry what a test needs to read.
const MiniTape = ({ title, testId, rows, range }) => {
  const length = range.toMs - range.fromMs
  return (
    <Box data-testid={testId} sx={{ mb: 1 }}>
      <Typography variant='caption' color='text.secondary'>{title}</Typography>
      {rows.map((row) => (
        <Box key={row.key} data-row={row.key} sx={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: 1, alignItems: 'center', mb: 0.5, fontSize: 11.5 }}>
          <Box component='span' sx={{ color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{row.label}</Box>
          <Box sx={{ position: 'relative', height: 14, bgcolor: 'action.hover', borderRadius: '2px', overflow: 'hidden' }}>
            {row.segments.map((segment) => (
              <i
                key={segment.key}
                data-seg={segment.key}
                data-mark={segment.mark}
                style={{
                  position: 'absolute',
                  top: 0,
                  bottom: 0,
                  left: `${((segment.startMs - range.fromMs) / length) * 100}%`,
                  width: `${((segment.endMs - segment.startMs) / length) * 100}%`,
                  background: TONE[segment.tone],
                  border: segment.mark === 'none' ? 'none' : '1px dashed #7fe1a7',
                  backgroundImage: segment.mark === 'filled' ? 'repeating-linear-gradient(135deg, rgba(255,255,255,.3) 0 3px, transparent 3px 6px)' : undefined
                }}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default MiniTape
